import firebase from 'firebase';


var fireConfig = {
  apiKey: "AIzaSyBgH8yIPJr9c12CbWVqtC1SqWNdZ0lR6Xo",
  authDomain: "beyond-education.firebaseapp.com",
  databaseURL: "https://beyond-education.firebaseio.com",
  projectId: "beyond-education",
  storageBucket: "beyond-education.appspot.com",
  messagingSenderId: "868785695919",
  appId: "1:868785695919:web:dbae4b46a2a55e7992b85a",
  measurementId: "G-59GMLX3SX5"
};

  
export const firebases = firebase.initializeApp(fireConfig);
export const files =firebase.storage().ref('files');
export const timeRef = firebase.database.ServerValue.TIMESTAMP;
export default firebases;